var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-3 mr-sm-0"},[_c('v-col',{staticClass:"styles"},[_vm._v("SURGEON GENERAL'S WARNING: Smoking Causes Lung Cancer, Heart Disease, Emphysema, And May Complicate Pregnancy.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }